import React, { useEffect, useState } from "react";
import MarkingFAQ from "../../components/MarkingFAQ";
import Notification from "../../components/Notification";
import axios from "axios";

const Marking = () => {
        const [studentIDs, setStudentIDs] = useState(["1"])
        const [selectedStudentIDs, setSelectedStudentIDs] = useState([]);
        const [allSelected, setAllSelected] = useState(false);
        const [slots, setSlots] = useState([]);
        const [selectedSlot, setSelectedSlot] = useState({ id: null, code: null });
        const [invoiceData, setInvoiceData] = useState({
                schoolName: null,
                schoolAddress: null,
                contactName: null,
                contactEmail: null,
                orderNumber: null,
                reference: null
        });
        const [terms, setTerms] = useState({ public_url: "", version: "" });
        const [termsStatus, setTermsStatus] = useState({
                accepted: false,
                ipAddress: null,
                userAgent: null,
        });

        const FEE = 15;

        const handleStudentCheck = (e) => {
                const id = e.target.getAttribute('student');

                if (e.target.checked) {
                        if (!selectedStudentIDs.includes(id)) {
                                setSelectedStudentIDs([...selectedStudentIDs, id]);
                        }
                } else {
                        setSelectedStudentIDs(selectedStudentIDs.filter(studentID => studentID !== id));
                }
        }

        const getLatestTerms = async () => {
                try {
                        const res = await axios.get("/api/terms/latest", {
                                withCredentials: true
                        });
                        return res.data;
                } catch (err) {
                        console.log(err.message);
                        return null;
                }
        };

        const fetchUserIP = async () => {
                try {
                        const res = await axios.get("https://api.ipify.org?format=json");
                        return res.data.ip;
                } catch (err) {
                        console.log(err);
                        return "";
                }
        }

        const handleTermsCheck = (e) => {
                if (e.target.checked) {
                        fetchUserIP().then((ip) => {
                                if (ip === "") {
                                        setTermsStatus((prev) => ({ ...prev, accepted: false }));
                                        alert("Unable to accept terms. Please make sure you are connected to the Internet.");
                                        return;
                                }
                                setTermsStatus({
                                        accepted: true,
                                        ipAddress: ip,
                                        userAgent: navigator.userAgent
                                });
                        })
                } else {
                        setTermsStatus((prev) => ({ ...prev, accepted: false }));
                }
        };

        const handleSelectAll = (e) => {
                if (allSelected) {
                        setAllSelected(false);
                        setSelectedStudentIDs([]);
                } else {
                        setAllSelected(true);
                        setSelectedStudentIDs(studentIDs);
                }
        }

        const handleInvoiceInput = (e) => {
                const dataLabel = e.target.getAttribute('datalabel');
                setInvoiceData((prev) => ({ ...prev, [dataLabel]: e.target.value.trim() }));
        }

        useEffect(() => {
                setAllSelected(selectedStudentIDs.length === studentIDs.length);
        }, [selectedStudentIDs])

        const inputsAreValid = () => {
                const requiredFields = ["schoolName", "schoolAddress", "contactName", "contactEmail"];
                return selectedSlot.code
                        && selectedStudentIDs.length > 0
                        && requiredFields.every(field => invoiceData[field] !== "")
                        && termsStatus.accepted;
        }

        const getSlots = async () => {
                const res = await axios.get("/api/slots/", {
                        withCredentials: true
                });

                return res.data;
        };

        useEffect(() => {
                try {
                        getSlots().then((data) => { setSlots(data) });
                        getLatestTerms().then((data) => { setTerms(data) });
                } catch (err) {
                        console.log(err);
                }
        }, []);

        const formattedDate = (date, monthLength = "short", year = undefined) => {
                return new Date(date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: monthLength,
                        year: year
                });
        };

        const handleSlotSelect = (id) => {
                const slot = slots.find(slot => slot.id === id);
                if (slot.is_closed) return;
                setSelectedSlot(slot);
        };

        const handleSubmit = async () => {
                if (!inputsAreValid) return;
                try {
                        const res = await axios.post("/api/slots/reserve", {
                                terms: { ...termsStatus, id: terms.id },
                                students: selectedStudentIDs,
                                slot: selectedSlot,
                                invoice: invoiceData
                        }, {
                                withCredentials: true
                        });

                        alert("Reservation successful!");
                } catch (err) {
                        alert(`Unable to make reservation. Please make sure you are connected to the Internet.`);
                }
        };

        const faqs = [
                {
                        question: "Why is external marking being offered?",
                        response: "External marking is being introduced following teacher feedback from last year.<br/><br/>We found that many teachers felt they didn't have time to mark their students' work, or that the exam contained topics or mathematics they were unsure of.<br/><br/>External marking is completely optional, and will neither advantage nor disadvantage students in any way."
                },
                {
                        question: "How do I submit my students' work?",
                        response: "Work will be submitted via email, to an email address specifically for external marking. You will receive this address directly following reservation.<br/><br/>With the address will be a marking code, that you must include in your submission email subject."
                },
                {
                        question: "When will I receive marking results?",
                        response: "The marks for your externally marked students may appear on your submissions page before it is closed at the end of round one. If this is not the case, your results will be available on the results day on 7th January 2026."
                },
                {
                        question: "How much does external marking cost?",
                        response: "The per-script fee is £15.00. This includes the marking of all written work and all code that is submitted."
                },
                {
                        question: "What if I miss my window deadline?",
                        response: "If you submit work later than the deadline for your reserved slot, we can make no guarantees about whether the work will be marked.<br/><br/>If it's late only by a few hours, we will try our best to mark it, but in the case that it is days late, it may not be possible. We will notify you, letting you know our position.<br/><br/>If a student has been unwell or unable to complete the exam during the expected window, we will still complete the late marking for that student. You should submit all work by other students on-time.<br/><br/>We cannot issue refunds for late submissions that don't get marked."
                },
                {
                        question: "How many windows/slots can I book?",
                        response: "You may only book one slot for one set of students."
                }
        ];

        return (
                // <div className="exm-panels">
                //         <div className="exm-panel">
                //                 <div className="exm-title">How it works</div>
                //                 <div className="exm-text">
                //                         Offload your marking to the BAO organisers.
                //                         <br /><br />
                //                         <ul>
                //                                 <li>Enter your invoicing details.</li>
                //                                 <li>Select the student(s) that you want externally marked.</li>
                //                                 <li>Choose a <b>marking window</b>*.</li>
                //                                 <li>Reserve the order, and wait for confirmation.</li>
                //                         </ul>

                //                         <span style={{ fontSize: "12px" }}>
                //                                 *Each marking window has a limited number of places that will be filled up on a rolling basis.
                //                                 You <b>must submit</b> your students' work by the end of your marking window, at 18:00 on the final day of the window.
                //                         </span>
                //                 </div>
                //                 <div className="exm-divider"></div>
                //                 <div className="exm-title">
                //                         FAQs
                //                 </div>

                //                 {faqs.map((faq, index) => (
                //                         <MarkingFAQ faq={faq} key={index} />
                //                 ))}
                //                 <br />
                //                 <span className="exm-subtitle">Find more information in the <a href={terms.public_url} target="_blank"><u>terms</u></a>.</span>
                //         </div>
                //         <div className="exm-panel">
                //                 <div className="exm-title">1. Invoicing details</div>
                //                 <input className="exm-input" placeholder="School Name for invoice" datalabel="schoolName" onChange={handleInvoiceInput} />
                //                 <input className="exm-input" placeholder="School Address" datalabel="schoolAddress" onChange={handleInvoiceInput} />
                //                 <div className="exm-input-group">
                //                         <input className="exm-input" placeholder="Contact name" datalabel="contactName" onChange={handleInvoiceInput} />
                //                         <input className="exm-input" placeholder="Contact email" datalabel="contactEmail" onChange={handleInvoiceInput} />
                //                 </div>
                //                 <div className="exm-input-group">
                //                         <input className="exm-input" placeholder="PO No. (optional)" datalabel="orderNumber" onChange={handleInvoiceInput} />
                //                         <input className="exm-input" placeholder="Reference (optional)" datalabel="reference" onChange={handleInvoiceInput} />
                //                 </div>

                //                 The BAO is not VAT registered.
                //                 <div className="exm-divider"></div>
                //                 <div className="exm-title">2. Select students</div>
                //                 {/* <span>Choose the students whose papers you'd like to have marked (column denoted <span style={{ fontFamily: "Medium" }}>ExtMk</span>).</span> */}
                //                 <div className="exm-table-controls">
                //                         <div className="exm-table-total">
                //                                 {selectedStudentIDs.length} {selectedStudentIDs.length != 1 ? "students" : "student"} selected
                //                         </div>
                //                         <button className="exm-table-selectall" onClick={handleSelectAll}>
                //                                 {!allSelected ? "Select All" : "Deselect All"}
                //                         </button>
                //                 </div>
                //                 <div className="exm-table-wrap">
                //                         <table className="exm-table">
                //                                 <thead>
                //                                         <tr>
                //                                                 <th>Student</th>
                //                                                 <th>No.</th>
                //                                                 <th>Ext. Mark</th>
                //                                         </tr>
                //                                 </thead>
                //                                 <tbody>
                //                                         <tr>
                //                                                 <td>Henry Hudson</td>
                //                                                 <td>3023</td>
                //                                                 <td><input type="checkbox" student="1" onChange={handleStudentCheck} checked={selectedStudentIDs.includes("1")} /></td>
                //                                         </tr>
                //                                 </tbody>
                //                         </table>
                //                 </div>
                //         </div>
                //         <div className="exm-panel">
                //                 <div className="exm-title">3. Choose a window</div>
                //                 {slots.map((slot, index) => {
                //                         return (
                //                                 <div
                //                                         key={index}
                //                                         className={`
                //                                                 exm-window
                //                                                 ${slot.is_closed ? "exm-disabled" : ""}
                //                                                 ${slot.id === selectedSlot.id ? "exm-window-selected" : ""}`}
                //                                         onClick={() => handleSlotSelect(slot.id)}
                //                                         slotid={slot.id}
                //                                 >
                //                                         <div className="exm-window-title">Week {slot.code}</div>
                //                                         <div className="exm-window-dates">
                //                                                 {slot.is_closed
                //                                                         ? "Slot Full"
                //                                                         : `${formattedDate(slot.slot_start)} – ${formattedDate(slot.slot_end)}`
                //                                                 }
                //                                         </div>
                //                                 </div>
                //                         );
                //                 })}
                //                 {selectedSlot.slot_end &&
                //                         <>
                //                                 <br />
                //                                 <div className="exm-iconbox">
                //                                         <img src="../icons/clock.svg" className="exm-iconbox-icon" />
                //                                         <div className="exm-iconbox-text">Submit work by 18:00 on {formattedDate(selectedSlot.slot_end, "short", "numeric")}</div>
                //                                 </div>
                //                         </>
                //                 }
                //                 <div className="exm-title">Summary</div>
                //                 <div className="exm-summary">
                //                         <div className="exm-summary-line">
                //                                 <span>Selected students</span>
                //                                 <span>{selectedStudentIDs.length}</span>
                //                         </div>
                //                         <div className="exm-summary-line">
                //                                 <span>Per-script fee</span>
                //                                 <span><span className="currency">£</span>{FEE}.00</span>
                //                         </div>
                //                         <div className="exm-summary-divider"></div>
                //                         <div className="exm-summary-line">
                //                                 <span>Total</span>
                //                                 <span><span className="currency">£</span>{selectedStudentIDs.length * FEE}.00</span>
                //                         </div>
                //                 </div><br />
                //                 <div className="exm-iconbox">
                //                         <input type="checkbox" className="exm-iconbox-icon" onChange={handleTermsCheck} checked={termsStatus.accepted} />
                //                         <div className="exm-iconbox-text">I agree to the <a href={terms.public_url} target="_blank"><u>terms</u></a><span style={{ color: "#222222" }}> (v{terms.version}, latest)</span>.</div>
                //                 </div>
                //                 <div className={`exm-reserve ${!inputsAreValid() ? 'exm-disabled' : ''}`} onClick={inputsAreValid() ? handleSubmit : () => { }}>
                //                         Reserve {!selectedSlot.code ? "Window" : `for Week ${selectedSlot.code}`}
                //                 </div>
                //         </div >
                // </div >
                <Notification text="This page is coming soon." subtext="External marking will open next year. Please contact us if you require marking assistance." />
        );
};

export default Marking;